import TablePageHeader from 'components/TablePageHeader';
import { usePaginatedItemsContext } from 'context/PaginatedItems/context/PaginatedItemsProvider';
import { PaginatedItems } from 'context/PaginatedItems/types/PaginatedItems';
import { defaultFilterValues } from 'features/Filters/utils/filterValues';
import { TableEntityType } from 'types/tableEntityType';
export interface IEntitiesTablePageHeaderProps {
  searchTerm: string;
}

const EntitiesTablePageHeader = ({ searchTerm }: IEntitiesTablePageHeaderProps) => {
  const { totalElements } = usePaginatedItemsContext() as PaginatedItems<TableEntityType>;

  return (
    <TablePageHeader
      title={
        searchTerm && (
          <>
            <b>{totalElements}</b> {`results for "${searchTerm}"`}
          </>
        )
      }
      titleVariant="body1"
      titleFontWeight={400}
      filterValues={defaultFilterValues}
    />
  );
};

export default EntitiesTablePageHeader;
